import { render, staticRenderFns } from "./ShadowSettings.vue?vue&type=template&id=5d4366b1&"
import script from "./ShadowSettings.vue?vue&type=script&lang=js&"
export * from "./ShadowSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports